import { Menu } from 'antd';
import styled from 'styled-components';

export const CMenuItem = styled(Menu.Item)`
  padding: 10px 18px;
  font-weight: ${props => props.theme.font.weight.regular} !important;
  color: ${props => props.theme.colors.text.secondary};

  .ant-dropdown-menu-title-content {
    display: flex;
    align-items: center;
  }
`;

export const CSubMenu = styled(Menu.SubMenu)`
  font-weight: ${props => props.theme.font.weight.regular} !important;
  color: ${props => props.theme.colors.text.secondary};

  .ant-dropdown-menu-item-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-dropdown-menu-title-content {
    font-weight: ${props => props.theme.font.weight.regular} !important;
  }

  .ant-dropdown-menu-submenu-title {
    padding: 10px 36px 10px 18px;
    display: flex;
    align-items: center;
  }

  .ant-dropdown-menu-submenu-expand-icon {
    right: 12px;
    display: flex;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export const Wrapper = styled.div``;
